import { useState } from "react";
import Badge from "./Badge";

export default function ExpandableCard({
  title = "",
  badge = null,
  primaryFields = [],
  extraFields = [],
  onView,
  viewLabel = "View",
}) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-3 space-y-2 shadow-md mb-2">
      {/* HEADER */}
      <div className="flex justify-between items-center">
        <div className="font-semibold text-sm text-slate-800">
          {title}
        </div>
        {badge && <Badge label={badge.label} color={badge.color} />}
      </div>

      {/* PRIMARY FIELDS */}
      <div className="text-xs text-slate-600 space-y-2">
        {primaryFields.map((f, i) => (
          <div key={i} className="space-y-0.5">
            <div className="font-medium text-slate-500">
              {f.label}
            </div>
            <div className="text-slate-800">
              {f.value ?? "-"}
            </div>
          </div>
        ))}
      </div>

      {/* EXTRA FIELDS */}
      {expanded && extraFields.length > 0 && (
        <div className="text-xs text-slate-600 space-y-2 border-t pt-2">
          {extraFields.map((f, i) => (
            <div key={i} className="space-y-0.5">
              <div className="font-medium text-slate-500">
                {f.label}
              </div>
              <div className="text-slate-800">
                {f.value ?? "-"}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ACTIONS */}
      <div className="flex justify-between items-center pt-2">
        {extraFields.length > 0 ? (
          <button
            onClick={() => setExpanded((p) => !p)}
            className="text-xs text-blue-600 font-medium"
          >
            {expanded ? "View Less" : "View More"}
          </button>
        ) : (
          <span />
        )}

        {onView && (
          <button
            onClick={onView}
            className="text-xs px-3 py-1 rounded-md bg-blue-600 text-white"
          >
            {viewLabel}
          </button>
        )}
      </div>
    </div>
  );
}



// import { useState } from "react";
// import Badge from "./Badge";

// export default function ExpandableCard({
//   title = "",
//   badge = null,
//   primaryFields = [],   // ✅ SAFE DEFAULT
//   extraFields = [],     // ✅ SAFE DEFAULT
//   onView,
//   viewLabel = "View",
// }) {
//   const [expanded, setExpanded] = useState(false);

//   return (
//     <div className="rounded-xl border border-slate-200 bg-white p-3 space-y-2 shadow-sm">
//       {/* HEADER */}
//       <div className="flex justify-between items-center">
//         <div className="font-semibold text-sm text-slate-800">
//           {title}
//         </div>

//         {badge && <Badge label={badge.label} color={badge.color} />}
//       </div>

//       {/* PRIMARY FIELDS */}
//       <div className="text-xs text-slate-600 space-y-1">
//         {primaryFields.map((f, i) => (
//           <p key={i}>
//             <b>{f.label}:</b> {f.value ?? "-"}
//           </p>
//         ))}
//       </div>

//       {/* EXTRA FIELDS */}
//       {expanded && extraFields.length > 0 && (
//         <div className="text-xs text-slate-600 space-y-1 border-t pt-2">
//           {extraFields.map((f, i) => (
//             <p key={i}>
//               <b>{f.label}:</b> {f.value ?? "-"}
//             </p>
//           ))}
//         </div>
//       )}

//       {/* ACTIONS */}
//       <div className="flex justify-between items-center pt-2">
//         {extraFields.length > 0 ? (
//           <button
//             onClick={() => setExpanded((p) => !p)}
//             className="text-xs text-blue-600 font-medium"
//           >
//             {expanded ? "View Less" : "View More"}
//           </button>
//         ) : (
//           <span />
//         )}

//         {onView && (
//           <button
//             onClick={onView}
//             className="text-xs px-3 py-1 rounded-md bg-blue-600 text-white"
//           >
//             {viewLabel}
//           </button>
//         )}
//       </div>
//     </div>
//   );
// }
